import React, {Component} from 'react';
import './App.css';
import Settings from './Settings.jsx';
import Display from './Display.jsx';
import Controls from './Controls.jsx';
import beep from './beep.mp3';
import gong from './gong.mp3';
import tick from './tick.mp3'


export default class App extends Component {
  constructor(props){
    super(props);
    this.state = {
       
       sessionLength: 25,
       breakLength: 5,
       status: false,
       chrono : [25,0],
       isStyleAlert : false
       
 
    }
    this.audioRef = new React.createRef()
    this.changeLengthUp = this.changeLengthUp.bind(this);
    this.changeLengthDown = this.changeLengthDown.bind(this);
    this.start = this.start.bind(this);
    this.decrease = this.decrease.bind(this);
    this.reset = this.reset.bind(this);
    this.changeBreakUp = this.changeBreakUp.bind(this);
    this.changeBreakDown = this.changeBreakDown.bind(this);
    
  }


  render(){
console.log(this.state.chrono)
    return (
      <div className="App">
          <div className="title">Simple Chrono</div>
          <div className="chrono-container">
              <Settings reset={this.reset} chrono={this.state.chrono} status={this.state.status} sessionLength={this.state.sessionLength} changeLengthUp={this.changeLengthUp} changeLengthDown={this.changeLengthDown} breakLength={this.state.breakLength} changeBreakUp={this.changeBreakUp} changeBreakDown={this.changeBreakDown}/>
              <Display  decrease={this.decrease} chrono={this.state.chrono} isStyleAlert={this.state.isStyleAlert}/>
              <Controls status={this.state.status} reset={this.reset} start={this.start} isStyleAlert={this.state.isStyleAlert}/>
          </div>
          <audio ref={this.audioRef}></audio>
          <div className="sign">Written and designed by Cesare Polonara </div> 
      </div>
    )
  }

 
  changeLengthUp(){
    this.state.sessionLength < 60 ?
    this.setState( state => (
      { 
        sessionLength: state.sessionLength + 1,
        chrono: [state.chrono[0]+1,0]
      }))
                                  :
        this.setState( state => (
      { 
        sessionLength: state.sessionLength,
        chrono: [state.chrono[0],0]
      }))                           
  }
  
  changeLengthDown(){
    this.state.sessionLength > 0 ?
    this.setState( state => (
      { 
        sessionLength: state.sessionLength - 1,
        chrono: [state.chrono[0]-1,0]
      }))
                                  :
        this.setState( state => (
      { 
        sessionLength: state.sessionLength,
        chrono: [state.chrono[0],0]
      }))                  
  }
  
  changeBreakUp(){
    this.state.breakLength < 60 ?
    this.setState( state => (
      { 
        breakLength: state.breakLength + 1,
        
      }))
                                  :
        this.setState( state => (
      { 
        breakLength: state.breakLength,
        
      }))                           
  }
  changeBreakDown(){
    this.state.breakLength > 0 ?
    this.setState( state => (
      { 
        breakLength: state.breakLength - 1,
        
      }))
                                  :
        this.setState( state => (
      { 
        breakLength: state.breakLength,
        
      }))                  
  }
  
  start(){
    if ( this.state.status) {
         clearInterval(this.state.myInterval);
         this.setState( state => ({
           status: false,
          }))
        }
         
       else {
    var count = setInterval(this.decrease,1000);
    this.setState( state => ({
      status: true,
      myInterval: count
    }));
   } 
  }

  decrease(){
   
   //sets the alertStyle when session gets to its last minute
    if (this.state.chrono[0] === 0 && this.state.chrono[1] === 59 && this.state.isStyleAlert === false) {
            
             
          this.audioRef.current.src = beep;
          this.audioRef.current.currentTime = 0;   
          this.audioRef.current.play();  
                               
              this.setState( state => ({
                                       chrono: [state.breakLength, 0],
                                       isStyleAlert: true
                                       }))
 
}
//keeps repeating break counter until it's manually stopped
if (this.state.chrono[0]===0 && this.state.chrono[1]===1){
          this.audioRef.current.src = gong;
          this.audioRef.current.currentTime = 0;   
          this.audioRef.current.play();  
  this.setState( state => ({
    chrono: [state.breakLength, 0],
    }))

}
    //during break it beeps
    if (this.state.isStyleAlert) {
                                  this.audioRef.current.src = beep;
                                  this.audioRef.current.currentTime = 0;   
                                  this.audioRef.current.play()  }
   //if it's a normal session counter it makes tick sounds
   else {
                                  this.audioRef.current.src = tick;
                                  this.audioRef.current.currentTime = 0;   
                                  this.audioRef.current.play()  }

                                
    this.state.chrono[1] === 0 ?
        this.setState( state => ({
            chrono: [state.chrono[0]-1,59]
                               })) :
        this.setState( state => ({
            chrono: [state.chrono[0],state.chrono[1]-1]
                                 }))
  }      

  reset(){
    clearInterval(this.state.myInterval);
    this.setState({
      sessionLength: 20,
      breakLength: 5,
         status: false,
         chrono : [20,0],
         isStyleAlert: false
    })
  }
  
 
  }


